<script setup lang="ts">
import { PopoverPanel } from '@headlessui/vue'

defineOptions({
    inheritAttrs: false,
})
</script>

<template>
    <Transition enter-active-class="transition duration-100 ease-out" enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-in" leave-from-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
        <PopoverPanel class="absolute left-0 px-1.5 py-0.5 mt-2 origin-top-left bg-white rounded shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" tabindex="-1" v-bind="$attrs">
            <slot />
        </PopoverPanel>
    </Transition>
</template>
